import { Box } from '@sendible/design-system/src';
import { styled } from 'styled-components';

export const SpinnerWrapper = styled(Box)`
  box-sizing: border-box;
  padding: 3rem;
  width: 100%;
`;
